import React, { useRef, useState, useEffect } from 'react';
import { Menu } from 'primereact/menu';
import { Button } from 'primereact/button';
import { Galleria } from 'primereact/galleria';
import _ from 'lodash';
import { useField } from 'formik';
import {v4 as uuid} from 'uuid';
import { useIsOpenControls } from 'hooks';
import { FormPageFieldComponentProps } from 'types/formPage';
import { withFormikFormControl } from '../../FormikFormControl';
import ModalInputURL from './ModalInputURL';
import ModalUploadFile from './ModalUploadFile';
import AttachmentViewer from './AttachmentViewer';
import ModalConfirmDelete from './ModalConfirmDelete';
import {Tooltip} from "primereact/tooltip";
import {Gallery} from "../../DisplayRendering/Gallery";
import {extract, FieldTypes, getAttachmentUrl, isDisplayStatus, toAttachment, toPixel} from "../../utils";
import {SelectButton} from "primereact/selectbutton";
import cls from './attachments.module.scss'
import DialogFullScreenView from "./DialogFullScreenView";


const AttachmentMenuItems = (allows, toggleUpload = (_type: AttachmentMode) => {}) => [
    ...(allows.file ? [{
    label: 'Upload from File',
    icon: 'pi pi-fw pi-file',
    command: () => toggleUpload('file'),
  }] : []),
    ...(allows.url ? [{
        label: 'Upload from URL',
        icon: 'pi pi-fw pi-link',
        command: () => toggleUpload('url'),
    }] : []),
];

export type AttachmentProps = FormPageFieldComponentProps & {view_only?:boolean};

export const Attachments = ({ value = [], name, view_only=false, extraConfig }: AttachmentProps) => {
  // eslint-disable-next-line
  const [field, meta, helpers] = useField(name);
  const [deleteUuid] = useState( uuid() )
  const refUpload = useRef<any>(null);
  const fileModalControls = useIsOpenControls();
  const urlModalControls = useIsOpenControls();
  const confirmModalControls = useIsOpenControls();
  const fsViewControls = useIsOpenControls();
  const [isDeleteMode, setIsDeleteMode] = useState(false);
  const [galIndex, setGalIndex] = useState(0);
  const refGallery = useRef(null);
  const disabled = isDisplayStatus(extraConfig, 'disable')
  const [selectedAttachments, setSelectedAttachments] = useState(new Array(value?.length).fill(false));
  const isEditable = !view_only && !['disable','display','hidden'].includes(extraConfig.display_status) && extraConfig.type === FieldTypes.FT_ATTACHMENTS
  const display_as = 'gallery'//extraConfig.display_as || 'gallery'
  const allow_create = extraConfig.allow_create && isEditable
  const allow_delete = extraConfig.allow_delete && isEditable
  const allows = {
      file: ['',null,undefined].includes(extraConfig.allow_file) ? true : extraConfig.allow_file,
      url: ['',null,undefined].includes(extraConfig.allow_url) ? true : extraConfig.allow_url,
  }
  const allows_single = !allows.file || !allows.url ? (allows.file ? 'file' : 'url') : ''
  const canDelete = isDeleteMode && selectedAttachments.filter((e) => e).length;
  console.log('Attachements Field', value, extraConfig, isEditable, allow_create, allow_delete)
  useEffect( () => {
    setSelectedAttachments(new Array(value?.length).fill(false));
  }, [value?.length])

  const handleAddAttachment = (type: AttachmentMode) => {
    if (type === 'file') {
      fileModalControls.handleOpen();
    } else if (type === 'url') {
      urlModalControls.handleOpen();
    }
  };

  const handleAddNewAttachments = (newAttachments: Omit<Attachment, 'id' | 'filename'>[]) => {
    const newValue = [...value, ...newAttachments]
    console.log('Uploaded New Files', newAttachments, newValue)
    helpers.setValue(newValue);
    helpers.setTouched(true);
    if(newAttachments.length)setGalIndex(value.length)
  };

  const handleCloseConfirmDialog = () => {
    setIsDeleteMode(false);
    setSelectedAttachments(new Array(value?.length).fill(false));

  };

  const handleDeleteAttachments = async () => {
    const update = value?.filter((_item, index) => !selectedAttachments[index]);
    setGalIndex(0)
    helpers.setValue(update);
    helpers.setTouched(true);
    confirmModalControls.handleClose();
    handleCloseConfirmDialog();
  };

  const handleDeleteClickBtn = (e) => {
    e.preventDefault();
    if(isDeleteMode){
        let temp = selectedAttachments.slice(0);
        temp = temp.map( t => false )
        setSelectedAttachments(temp);
    }
    setIsDeleteMode( !isDeleteMode );

  };

  const handleDeleteAttachmentsBtn = (e) => {
    e.preventDefault()
    if(canDelete)confirmModalControls.handleOpen();
  }

  const handleClickAttachment = (index: number) => {
    if (isDeleteMode) {
      const temp = selectedAttachments.slice(0);
      temp[index] = !temp[index];
      setSelectedAttachments(temp);
    } else {
      setGalIndex(index);
      refGallery.current.show();
    }
  };
  const fullscreenAttachment = (e) => {
    e.preventDefault()
    fsViewControls.handleOpen()
  }

  const previewHeight = toPixel( extraConfig['previewHeight'], undefined)
  const thumbnailHeight = toPixel( extraConfig['thumbnailHeight'], display_as === 'gallery' ? '100px' : '200px')
  const trashOverlay = <Button
      className={`p-button-danger p-button-lg`}
      type="reset"
      icon={"pi pi-trash"}
      disabled={true}
      style={{
        top: 0,
        right: 0,
        cursor: 'pointer',
        position: 'absolute',
        width: '30px',
        height: '30px',
      }}

  />
  const expandOverlay = <Button
      className={`p-button-secondary p-button-lg`}
      type="reset"
      icon={"pi pi-window-maximize"}
      onClick={fullscreenAttachment}
      tooltip={'View Full Screen'}
      style={{
        top: 0,
        left: 0,
        position: 'absolute',
        width: '30px',
        height: '30px',
      }}

  />

  const itemTemplate = (item) => {
      item = toAttachment(item)
      console.log('Item Template Gallery Attachment',isDeleteMode, item)
      return <div style={{minWidth: '100%'}}>
        <AttachmentViewer attachment={item} height={previewHeight} env={'field'} />
        {isDeleteMode && selectedAttachments[galIndex] && trashOverlay}
        {!isDeleteMode && expandOverlay}
      </div>

  };

  const hasImage = (item) => {
      item = toAttachment(item)
      return _.get(item,'thumbnails.large.url') || ['jpg','jpeg', 'png', 'gif'].includes(item.ext)
  }
  const thumbnailTemplate = (item) => {
    item = toAttachment(item)
    const url = hasImage(item) ? getAttachmentUrl(item, ['thumbnails.large.url', 'thumbnails.small.url', 'thumbnails.full.url', 'url']) : null
    const inner = url ? <img src={url} alt={item.filename} style={{ display: 'block', height: thumbnailHeight, maxWidth: '100%' }} /> : <span style={{height: thumbnailHeight, color: 'white'}}>{item.filename || 'No Thumbnail Available'}</span>
    const index = (value || []).indexOf(item)
    if(isDeleteMode && index >= 0 && selectedAttachments[index] ){
      return <div style={{position: 'relative'}}>
        {inner}
        {trashOverlay}
      </div>
    }
    return inner
  };
  const onGallerySelect = (index) => {
    setGalIndex(index);

  }
  const galleryHeader = () => {
    if(isDeleteMode){
      const allDeleted =  selectedAttachments.find( a => !a) === undefined
      const deleteValue = selectedAttachments[galIndex] ? 'delete' : 'keep'
      const toggleDeleteTemplate = (item) => {
       return <i className={`pi pi-${item.icon}`}>{' '}{item.label}</i>;
      }
      const onToggleDeleteChange = (e) => {
        let temp = selectedAttachments.slice(0);
        if(e.value.includes('_all')){
          temp = temp.map( t => e.value === 'delete_all')
        }else{
          temp[galIndex] = e.value === 'delete';
        }

        setSelectedAttachments(temp);
      }
      const deleteOptions = [{value: 'keep', label: 'KEEP ATTACHMENT', icon: 'check'}
        ,{value: 'delete',  label: 'REMOVE ATTACHMENT', icon: 'trash'}
        ,{value: allDeleted ? 'clear_all' : 'delete_all',  label: (allDeleted ? 'KEEP' : 'REMOVE') + ' ALL ATTACHMENTS', icon: allDeleted ? 'check' : 'trash'}]
      return (
          <div className={cls.galleryRemove}>
           <SelectButton multiple={false} value={deleteValue} itemTemplate={toggleDeleteTemplate} onChange={onToggleDeleteChange} options={deleteOptions} style={{width: '100%'}} />
          </div>
      )
    }
    return <></>
  }
  const deletes = () => {
    return allow_delete && (value || []).length ? (
        <>
          <Tooltip target={`.button-${deleteUuid}`} />
          <Button
              className={`button-${deleteUuid} button-rounded button-sm ${isDeleteMode ? 'p-button-secondary' : 'p-button-info'}`}
              type="reset"
              icon={isDeleteMode ? "pi pi-undo" : "pi pi-trash"}
              disabled={disabled || !value.length}
              onClick={handleDeleteClickBtn}
              style={{
                top: '-40px',
                right: 0,
                cursor: 'pointer',
                position: 'absolute',
                width: '30px',
                height: '30px',
              }}
              data-pr-tooltip={isDeleteMode ? 'Click to Cancel Delete Mode' : 'Click to Begin Delete mode'}
          />
          <ModalConfirmDelete
              selectedAttachments={selectedAttachments}
              onClose={handleCloseConfirmDialog}
              onDelete={handleDeleteAttachments}
              {...confirmModalControls}
          />
        </>
    ) : <></>
  }
  const upload = () => {
    return allow_create ? (
        <>
          <Menu ref={refUpload} popup model={AttachmentMenuItems(allows,handleAddAttachment)} id="popup_add_attachment" />
          <ModalInputURL onChangeAttachments={handleAddNewAttachments} {...urlModalControls} />
          <ModalUploadFile onChangeAttachments={handleAddNewAttachments} {...fileModalControls} extraConfig={extraConfig} />
        </>
    ) : <></>
  }
  const typeLabel = item => _.toUpper(item.type?.split('/') && item.type?.split('/').length > 0
      ? item.type?.split('/')[1]
      : item.type?.split('/')[0])
  if(display_as === 'gallery'){
    //console.log('Gallery Attachment', value, extraConfig)
    return (
        <div style={{ position: 'relative' }}>
          {deletes()}
          {(value || []).length > 0 ?
          <Gallery env={'field'} value={value || []} render={itemTemplate} activeIndex={galIndex} onItemChange={onGallerySelect} thumbnail={thumbnailTemplate} extraConfig={{header: galleryHeader(), showThumbnails: false, ...extraConfig}} />
              : <p>{extraConfig['emptyMessage'] || 'No Attachments'}</p>}
          {isDeleteMode ? <Button
                type='reset'
                icon={canDelete ? "pi pi-trash" : "pi pi-arrow-up"}
                className={`button-${deleteUuid} p-button-${canDelete ? 'danger' : 'secondary'}`}
                label={canDelete ? 'Delete Selected Attachments' : 'Select Attachments to Delete'}
                onClick={handleDeleteAttachmentsBtn}
            /> : allow_create ? <Button
            type="reset"
            icon="pi pi-plus"
            label={'Add Attachment'}
            onClick={(e) => {
            e.preventDefault();
            if(allows_single){
                handleAddAttachment(allows_single)
            }else {
                refUpload?.current?.toggle(e);
            }
          }}
            aria-controls="popup_add_attachment"
            aria-haspopup

            /> : <></>}

          {upload()}
          {fsViewControls.isOpen && <DialogFullScreenView handleClose={() => fsViewControls.handleClose()} isOpen={fsViewControls.isOpen} attachment={toAttachment(value[galIndex])} {...fsViewControls}/>}
          </div>
    )
  }

};

export const AttachmentsFormik = withFormikFormControl()(Attachments);

export default AttachmentsFormik;
